import { useSelector } from "react-redux";
import React, { useEffect, useRef, useState } from "react";
import { Modal, Row, Col, Button, Form } from "react-bootstrap";
import APICom from "../../utils/helpers/APICom.js";
import { Icon } from '@iconify/react';
import PhoneInput from "react-phone-number-input/input";

import DateTimeUtils from "../../utils/DateTimeUtility.js";

const ClientProfile = (props) => {

  const { GlobalASCSData, ASCSSettingData, AffiliateData, FamilyData, FundingSourceData } = useSelector((store) => store.combinedata);
  const { loginData }  = useSelector((store) => store.login);
  
  const [homeAddr, setHomeAddr] = useState('');
  const [inputSuggestionListAddress, setInputSuggestionListAddress] = useState(null);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const [showDynamicModal, setShowDynamicModal] = useState(props.showClientProfile);
  const [showDynamicExtraModal, setShowDynamicExtraModal] = useState('');
  const [modalHeaderTextExtra, setModalHeaderTextExtra] = useState('');
  const [modalBodyHTMLExtra, setModalBodyHTMLExtra] = useState('');
  const [modalFooterHTMLExtra, setModalFooterHTMLExtra] = useState('');

  const [clientFirstName, setClientFirstName] = useState("");
  const [clientLastName, setClientLastName] = useState("");
  const [addrLat, setAddrLat] = useState("");
  const [addrLng, setAddrLng] = useState("");
  const [homePOI, setHomePOI] = useState("");
  const [ShowAPILoader, setShowAPILoader] = useState(false);
  const [activeProfile, setActiveProfile] = useState('yes');
  const [showPhone, setShowPhone] = useState('yes');
  const [mobilityType, setMobilityType] = useState('amb');
  const [providedAff, setProvidedAff] = useState(props.selectedAff);
  const [selectedFamilyID, setSelectedFamilyID] = useState('DTSP');
  const [selectedCompanyName, setSelectedCompanyName] = useState('');
  const [selectedLanguage, setSelectedLanguage] = useState('Language');
  const [selectedStatus, setSelectedStatus] = useState('Status');
  const [DTSPOptionsHTML, setDTSPOptionsHTML] = useState(null);
  const [statusOptionsHTML, setStatusOptionsHTML] = useState(null);
  const [languageOptionsHTML, setLanguageOptionsHTML] = useState(null);
  const [profileContactInfo, setProfileContactInfo] = useState({phone: null, cell: null, office: null, email: '', DOB: ''});
  const [tripInfo, setTripInfo] = useState({SLA: 5, remarks: '', agentNotes: '', RollCall: {phone: false, email: false, sms: false}});
  const [screenWidth, setScreenWidthSize] = useState(window.innerWidth);
  const [enteredMainInfoFlag, setEnteredMainInfoFlag] = useState({phone: false, name: false});
  const [paymentInfo, setPaymentInfo] = useState({accountNo: '', payID: -1, FSID: -1});
  const [statusOptionsArr, setStatusOptionsArr] = useState([]);

  const focusedSuggestionCheckAddress = useRef(false);
  const homePOITimerIntervalRef = useRef(null); //Timer for user entry on HOME address
  const homeTimerIntervalRef = useRef(null); //Timer for user entry on HOME address
  const liRefs = useRef([]); // Array to hold refs for each <li> HOME
  const liRefHomeAddressComponent = useRef([]); // Array to hold refs for each <li> HOME
  const homeAddrLatLng = useRef("");
  const xCancelSourceForGrid = useRef(null);
  const createNewProfileBtnRef = useRef(null);
  const addressInfoDetails = useRef("");
  const OSRM_Username = useRef(GlobalASCSData.find(dict => dict.SubTitle === "ITCMapServiceUserName").value);
  const OSRM_Password = useRef(GlobalASCSData.find(dict => dict.SubTitle === "ITCMapServicePassword").value);
  const ITCMapURL = useRef((GlobalASCSData.find(dict => dict.SubTitle === "ITCMapServiceURL").value ? GlobalASCSData.find(dict => dict.SubTitle === "ITCMapServiceURL").value + "autocomplete?address=": "http://itcmap.itcurves.us/api/Map/autocomplete?address="));

  useEffect(() => {
    try{
      const languageTypes = ["English", "Spanish", "Chinese", "Tagalog", "Vietnamese", "Arabic", "French", "Korean", "Russian", "Haitian Creole",
        "Hindi", "Portuguese", "Italian", "Polish", "Urdu", "Japanese", "Persian", "Gujarati", "Telugu", "Bengali", "Greek", "Punjabi", "Tamil", 
        "Armenian", "Serbo-Croatian", "Hebrew"
      ];
      let selectedFamilyData = AffiliateData.filter((item)=>{
        if(parseInt(item.AffiliateID) === parseInt(providedAff))
        {
          return true;
        }
      });

      let familyOptions = FamilyData.map(function(item, index){
        if(loginData.AssociatedFamilyIDs.includes(String(item.iATSPGroupID)))
        {
          return(
            <option key={index} value={item.iATSPGroupID}>{item.vATSPGroupName}</option>
          );
        }
      });
      let languageOptions = languageTypes.map(function(item, index){
        return(
          <option key={index} value={(index+1)}>{item}</option>
        );
      });
      let resizeTimeout = 0;
      let mainInfoSearchFlag = props.disabledField;
      let newAffFSData = (FundingSourceData[parseInt(providedAff)] ? JSON.parse(FundingSourceData[parseInt(providedAff)]) : []);
      const newFSFiltered = (newAffFSData.length > 0 ? newAffFSData[0] : []);

      if(typeof newFSFiltered === 'object'){
        let activeProf = (newFSFiltered.Active ? 'yes' : 'no');
        let paymentType = (newFSFiltered.PaymentTypeID || -1);
        let priorityType = newFSFiltered.SLAClassID ? parseInt(newFSFiltered.SLAClassID) : 5;
        let accountNo = newFSFiltered.AccountNumber ? newFSFiltered.AccountNumber : '';
        let fsID = newFSFiltered.FID;
        setTripInfo(prev=>({...prev, SLA: priorityType}));
        setActiveProfile(activeProf);
        setPaymentInfo({accountNo: accountNo, payID: paymentType, FSID:parseInt(fsID)})
      }
      if(props.disabledField){ //Adding data from previous screen to the fields
        if(mainInfoSearchFlag.type === 'name'){
          const fullName = mainInfoSearchFlag.value.trim();
          let firstNameVF = fullName.includes(",") ? fullName.split(",")[1].trim() : (fullName.includes(" ")? fullName.split(" ")[0].trim(): fullName);
          let lastNameVF = fullName.includes(",") ? fullName.split(",")[0].trim() : (fullName.includes(" ")? fullName.replace(firstNameVF, "").trim(): "");
          setEnteredMainInfoFlag(prev=>({...prev, [mainInfoSearchFlag.type] : true}));
          setClientFirstName(firstNameVF);
          setClientLastName(lastNameVF);
        }
        else if(mainInfoSearchFlag.type === 'phone'){
          setEnteredMainInfoFlag(prev=>({...prev, [mainInfoSearchFlag.type] : true}));
          setProfileContactInfo(prevState=>({...prevState, phone: mainInfoSearchFlag.value}));
        }
      }
      if(props.extraInfo){ //Adding data from previous screen to the fields
        const extraInfo = props.extraInfo;
        if(props.disabledField && props.disabledField.type !== 'name') {
          const fullName = extraInfo.name.trim();
          let firstNameVF = fullName.includes(",") ? fullName.split(",")[1].trim() : (fullName.includes(" ")? fullName.split(" ")[0].trim(): fullName);
          let lastNameVF = fullName.includes(",") ? fullName.split(",")[0].trim() : (fullName.includes(" ")? fullName.replace(firstNameVF, "").trim(): "");
          setClientFirstName(firstNameVF);
          setClientLastName(lastNameVF);
        }
        setSelectedLanguage(extraInfo.language);
        setTripInfo({SLA: parseInt(extraInfo.priority), remarks: extraInfo.remarks, agentNotes: extraInfo.agentNotes, RollCall: extraInfo.rollcall});
        setProfileContactInfo(prevState=>({...prevState, email: extraInfo.email}));
        setMobilityType(extraInfo.passType);
      }
      setSelectedCompanyName((selectedFamilyData.length > 0 ? String(selectedFamilyData[0].vATSPGroupName) : 'DTSP'));
      setSelectedFamilyID((selectedFamilyData.length > 0 ? String(selectedFamilyData[0].DTSPID) : 'DTSP'));
      handleClientStatusDropdownGeneration((selectedFamilyData.length > 0 ? String(selectedFamilyData[0].DTSPID) : 'DTSP'));
      setDTSPOptionsHTML(familyOptions);
      setLanguageOptionsHTML(languageOptions);
      
      const handleResize = () =>{
        try{
          clearTimeout(resizeTimeout); //clear if resizing continues
          resizeTimeout = setTimeout(() => {
            setScreenWidthSize(window.innerWidth);
          }, 100);
        }
        catch(err){console.log(err);}
      };
      
      window.addEventListener('resize', handleResize);

      return () => {
        clearTimeout(resizeTimeout); //clearing screen resize timer
        window.removeEventListener('resize', handleResize);
      };

    } 
    catch(err){console.log(err);}
  }, []);

  async function handleClientStatusDropdownGeneration (familyID) {
    try{
      let data = {
        "atspFamilyID": (familyID === 'DTSP' ? 0 : parseInt(familyID)),
      };
      let response = await APICom.fetchData("ReservationCoreURL","api/ParatransitCT/GetClientStatus", "post", { "Content-Type": "application/json" }, data, null);
      if(response && response.error === ''){
        // console.log(response);
        const statusOptions = response.data;
        setStatusOptionsArr((statusOptions.length > 0 ? statusOptions : []));
        const statusOptionsHTMLTemp = (statusOptions.length > 0 ? statusOptions.map(function (item, index){
          return(
            <option key={index} value={item.iID}>{item.vName}</option>
          );
        }) : []);
        setStatusOptionsHTML(statusOptionsHTMLTemp);
      }

    }
    catch(err){console.log(err); }
  }

  function customHideFunc () {
    try{
      props.setShowClientProfile(false);
      setShowDynamicModal(false);
    }
    catch(err){console.log(err); props.setShowClientProfile(false);}
  }

  function headersToObject (headers) {
    try{
      let result = {};
      for (let [key, value] of headers.entries()) {
        result[key] = value;
      }
      return result;
    }
    catch(err){console.log(err); return [];}
  };

  async function handleOSRMAutoComplete (input = "") {
    try{
      let myHeaders = new Headers();
        myHeaders.append("Authorization", 'Basic ' + btoa(OSRM_Username.current + ":" + OSRM_Password.current));
        myHeaders.append('Content-Type', 'application/json');
      let headersObj = headersToObject(myHeaders);
      let mapBounds = (JSON.parse(ASCSSettingData[providedAff]).find((item)=>item.SubTitle === "OSRMRectangleBounds")).value.replace(" ", ""); //"&bounds="+mapBounds+
      let addressAPI = ITCMapURL.current + encodeURIComponent(input) + "&bounds="+mapBounds+ "&AppType=Web_Reservation";
      let OSRMResponse = await APICom.fetchData("full", addressAPI, "get", headersObj, {});
      return OSRMResponse;
    }
    catch(err){console.log(err); return null;}
  }

  function ParseGeoCodedData (data, Identifier, Index = 0) {  
    try{
      let StreatNum = "", route = "", Locality = "", Admin3 = "", Admin2 = "", Admin1 = "", Country = "", PostalCode = "",
      establishment = "", neighborhood = "", park = "", premise = "", subpremise = "", sublocality = "", intersection = "", 
      FormatedAddress = "";
      let StreatNum_short = "", route_short = "", neighborhood_short = "", park_short = "", premise_short = "", 
      subpremise_short = "", intersection_short = ""; //Initializing all necessary pieces of address data to be assigned from given data
      let _mapSource = "unkwnSource";
      let isPoiLatLong = false;
      //Assigning each variable to accurate component of OSRM using switch case
      if(data.address_components){
        data.address_components.forEach((component) => {
          const componentType = component.types[0];
          const longName = component.long_name;
          const shortName = component.short_name;

          switch (componentType) {
            case 'street_number': StreatNum = longName; StreatNum_short = shortName;
              break;
            case 'route': route = longName; route_short = shortName;
              break;
            case 'locality': Locality = longName;
              break;
            case 'administrative_area_level_3': Admin3 = longName;
              break;
            case 'administrative_area_level_2': Admin2 = longName;
              break;
            case 'administrative_area_level_1': Admin1 = shortName;
              break;
            case 'country': Country = longName;
              break;
            case 'postal_code': PostalCode = longName;
              break;
            case 'establishment': establishment = longName;
              break;
            case 'neighborhood': neighborhood = longName; neighborhood_short = shortName;
              break;
            case 'park': park = longName; park_short = shortName;
              break;
            case 'premise': premise = longName; premise_short = shortName;
              break;
            case 'subpremise': subpremise = longName; subpremise_short = shortName;
              break;
            case 'sublocality': sublocality = longName;
              break;
            case 'intersection': intersection = longName; intersection_short = shortName;
              break;
            default: break;
          }
        });
      }
      FormatedAddress = data.formatted_address;
      if (Admin1.trim() === Country.trim()) {//If it sends country in state, empty the state.
        Admin1 = "";
      }
      let AggregatedStreetAdddr = "";
      AggregatedStreetAdddr = (premise.trim() === "" ? "" : premise + ", ") + 
        (subpremise.trim() === "" ? "" : subpremise + ", ") + (park.trim() === "" ? "" : park + ", ") + 
        ((neighborhood.trim() === "" || route !== "" || StreatNum !== "") ? "" : neighborhood + ", ") + 
      (intersection.trim() === "" ? "" : intersection + ", ") + StreatNum + " " + route;
      
  
      try {
        if (FormatedAddress.split(',').length > 0) {

          let StreetAdd = data.formatted_address.split(',')[0];
          if (StreetAdd != "" && StreetAdd.indexOf("&") > -1 && (StreetAdd.indexOf(route) > -1 || StreetAdd.indexOf(StreatNum) > -1
            || StreetAdd.indexOf(intersection) > -1 || StreetAdd.indexOf(neighborhood) > -1 || StreetAdd.indexOf(park) > -1
            || StreetAdd.indexOf(subpremise) > -1 || StreetAdd.indexOf(premise) > -1
            || StreetAdd.indexOf(route_short) > -1 || StreetAdd.indexOf(StreatNum_short) > -1
            || StreetAdd.indexOf(intersection_short) > -1 || StreetAdd.indexOf(neighborhood_short) > -1
            || StreetAdd.indexOf(park_short) > -1 || StreetAdd.indexOf(subpremise_short) > -1 || StreetAdd.indexOf(premise_short) > -1)) 
          {
            AggregatedStreetAdddr = StreetAdd;
          }
        }
      } catch (CrashFailSafe) { }
      
      try {
        if (typeof data.mapSource !== 'undefined') {
          _mapSource = data.mapSource;
        }
        if (typeof data.placessearchedresult !== 'undefined') {
          if (data.placessearchedresult === true) {
            isPoiLatLong = true;
          }
        }
      } catch (setMapSrcExp) { }
      let ParsedData = {
        "Street": AggregatedStreetAdddr.trim() === "" ? establishment : AggregatedStreetAdddr.trim(),
        "City": (Locality === "") ? Admin2 : Locality,
        "State": (Admin1.toString().toLowerCase() === "maryland") ? 'MD' : Admin1,
        "Zip": PostalCode,
        "Lat": (data.geometry ? data.geometry.location.lat : ""),
        "Long": (data.geometry ? data.geometry.location.lng : ""),
        "Address": FormatedAddress,
        "data": data,
        "Country": Country,
        "Identifier": Identifier,
        "isPoiLatLong": isPoiLatLong,
        "UnitNumber": (data.sUnitNumber === undefined || data.sUnitNumber === null) ? "" : data.sUnitNumber,
        "GeocodeSource": _mapSource
      };
      return ParsedData;
    }
    catch(err){console.log(err);}
  }

  async function handleHomeAddressSuggestion (e) {
    try{
      let input = e.target.value;
      if(input === homeAddr && homeAddrLatLng.current !== ""){return;} //check for no change in input
      if(input.trim() === ""){
        setHomePOI("");
      }

      homeAddrLatLng.current = "";
      liRefs.current = [];

      let poiSuggestionAddrHTML = null;
      let hashIndex = input.indexOf("#");
      let trimmedInput = input.trim();
      let lastInput = trimmedInput;
      let elapsedTime = 0;
      let timeInterval = 300;

      if(hashIndex !== -1)
      {
        input = input.slice(hashIndex);
        setHomeAddr(input);
        input = input.replaceAll("#","");

        if(homePOITimerIntervalRef.current){clearInterval(homePOITimerIntervalRef.current);}

        if(trimmedInput !== "")
        {
          homePOITimerIntervalRef.current = setInterval(async () => {
            try{
              if(lastInput === homeAddr.trim())
              {
                //No change occured
                elapsedTime += 100;
              }
              else
              {
                //A change occured, reset timer
                lastInput = homeAddr.trim();
                elapsedTime = 0;
              }
              if(elapsedTime >= timeInterval)
              {
                clearInterval(homePOITimerIntervalRef.current);
                if(lastInput.length >= 3)
                {
                  let data = {
                    "affiliateID": parseInt(providedAff),
                    "poi": input.replaceAll("#",""),
                  }
                  xCancelSourceForGrid.current = APICom.GenerateSource();
                  let response = await APICom.fetchData("ReservationCoreURL","api/ParatransitCT/GetPOISuggestion", "post", 
                    {'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': '*',
                    'mode': 'no-cors'}, data, xCancelSourceForGrid.current
                  );
        
                  if(response.error.length === 0 && (Array.isArray(response.data) && response.data.length > 0))
                  {
                    let SuggestedAddrArray = response.data;
                    let filteredPOISuggestion = SuggestedAddrArray.filter(item=>{
                      let formattedAddr = item.POI;
                      return formattedAddr.toLowerCase().includes(input.trim().toLowerCase());
                    });
                    focusedSuggestionCheckAddress.current = false;
                    poiSuggestionAddrHTML = filteredPOISuggestion ? filteredPOISuggestion.map(function(item, index){
                      let detailedData = item.City+","+item.Region+","+item.ZipCode;
                      let formattedAddr = item.POI;
                      let fullAddr = (item.Street + (item.City && item.City !== ""? ", "+item.City +", "+ (item.Region && item.Region !== "" ? item.Region +" "+ item.ZipCode: ""): "") );
                      let LatLng = String(item.vPOILatitude)+","+String(item.vPOILongitude);
                      liRefs.current[index] = React.createRef();
                      return(
                        <li ref={liRefs.current[index]} poisuggestion={"true"} className="small border-bottom text-nowrap overflow-hidden addressSelectionRow" 
                          title={fullAddr} onFocus={()=>{focusedSuggestionCheckAddress.current = true;}}
                          style={{cursor:"pointer"}} tabIndex={-1} onBlur={()=>{focusedSuggestionCheckAddress.current = false;}} onKeyDown={(e)=>{
                            if(e.key === 'ArrowDown')
                            {
                              e.preventDefault();
        
                              if(liRefs.current.length > 0)
                              {
                                setHighlightedIndex((prevIndex) => {
                                  const newIndex = (prevIndex + 1) % liRefs.current.length;
                                  liRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                                  return newIndex;
                                });
                              }
                            }
                            else if (e.key === 'ArrowUp') {
                              e.preventDefault();
                              if(liRefs.current.length > 0)
                              {
                                setHighlightedIndex((prevIndex) => {
                                  const newIndex = (prevIndex - 1 + liRefs.current.length) % liRefs.current.length;
                                  liRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                                  return newIndex;
                                });
                              }
                            }
                            else if(e.key === "Enter")
                            {
                              handleHomeSuggestionSelected(e);
                            }
                          }}
                          onClick={handleHomeSuggestionSelected} key={index} value={formattedAddr} data-name={detailedData} data-virtual={LatLng}
                        >
                          {item.icon && item.icon !== ""? <Icon icon={item.icon} className="text-success me-1" style={{width:"20px", height:"20px"}}/> :
                            <Icon icon={"gis:search-poi"} className="text-success me-1" style={{width:"20px", height:"20px"}}/>
                          }
                          {formattedAddr}
                        </li>
                      );
                    }) : "";
                    setInputSuggestionListAddress(poiSuggestionAddrHTML);
                  }
                }
              }
            } catch(err){console.log(err);}
          }, timeInterval);
        }
      }
      else{
        setHomeAddr(input);
      }

      elapsedTime = 0;
      timeInterval = 400;
      if(homeTimerIntervalRef.current){clearInterval(homeTimerIntervalRef.current);}
      if(trimmedInput !== "" && hashIndex === -1) {
        homeTimerIntervalRef.current = setInterval(async () => {
          try{
            if(lastInput === homeAddr.trim())
            {
              //No change occured
              elapsedTime += 100;
            }
            else
            {
              //A change occured, reset timer
              if(homeAddr.trim() === ""){elapsedTime = timeInterval;}
              else{
                lastInput = homeAddr.trim();
                elapsedTime = 0;
              }
              
            }
            if(elapsedTime >= timeInterval)
            {
              clearInterval(homeTimerIntervalRef.current);
              if(lastInput.length > 8)
              {
                let OSRMResponse = await handleOSRMAutoComplete(input.trim());
                let SuggestedAddrArray = [];

                if(OSRMResponse && OSRMResponse.data.status.toUpperCase() === "OK")
                {
                  SuggestedAddrArray = OSRMResponse.data.results.map(function(item)
                  {
                    return item;
                  });

                  liRefs.current = [];
                  liRefHomeAddressComponent.current = [];
                  focusedSuggestionCheckAddress.current = false;
                  if(SuggestedAddrArray.length > 0)
                  {
                    SuggestedAddrArray.unshift({
                      Address: "",
                      City: "",
                      State: "",
                      Zip: "",
                      Lat: "",
                      Long: "",
                      AddressType: 0,
                      isStatic: true, // Add a flag to differentiate this static entry
                    });
                  }

                  let suggestionsHTML2_0 = handleGetSuggestionsList(SuggestedAddrArray, input.trim(), liRefHomeAddressComponent, liRefs, focusedSuggestionCheckAddress, setHighlightedIndex, handleHomeSuggestionSelected, "", "AutoComplete");

                  if(suggestionsHTML2_0 !== "" && e.target.value !== "")
                  {
                    setInputSuggestionListAddress(suggestionsHTML2_0);
                  }
                }        
              }
            }
          }
          catch(err){console.log(err);}
        }, timeInterval);
      }

      if(input.trim().length === 0)
      {
        setInputSuggestionListAddress("");
      }
      else
      {
        if(hashIndex !== -1 && poiSuggestionAddrHTML !== "")
        {
          setInputSuggestionListAddress(poiSuggestionAddrHTML);
        }
        else
        {
          setInputSuggestionListAddress("");
        }
      }

    }
    catch(err){console.log(err);}
  }

  function handleGetSuggestionsList (sortedAddrArr = [], trimmedInput = "", addressComponentRef = [], optionRef = [], focusedOptionRef = false, highlightIndexSetter = null, handleFunction = null, isRecent = "", type = "") {
    try{
      let suggestionHTML = sortedAddrArr && sortedAddrArr.length > 0 ? sortedAddrArr.map((item, index) => {
        optionRef.current[index] = React.createRef();
        let formattedAddr = (type === "" ? item.Address+", "+item.City+", "+item.State+" "+item.Zip+", USA" : item.formatted_address);
        let detailedData = (type === "" ? item.City+","+item.State+","+item.Zip : "");
        let LatLng = (type === "" ? String(item.Lat)+","+String(item.Long) : "");
        const inputFilter = (trimmedInput.length > 0 && formattedAddr && formattedAddr.toLowerCase().includes(trimmedInput.toLowerCase()));
        const shouldShowAll = (trimmedInput === "" || isRecent === "");
        const isStatic = item.isStatic;
        const isRecentAddress = (isRecent !== "" ? {isrecentaddress:"true", recentaddressindex: index } : {index: index});
        
        if(isStatic)
        {
          return (
            <li ref={optionRef.current[index]} className="small border-bottom text-nowrap overflow-hidden addressSelectionRow"
              onFocus={() => { focusedOptionRef.current = true;}}
              style={{ cursor: "pointer" }} tabIndex={-1} onBlur={() => { focusedOptionRef.current = false; }}
              onKeyDown={(e)=>{if(e.key === 'ArrowDown')
                {
                  e.preventDefault();
                  if(optionRef.current.length > 0)
                  {
                    highlightIndexSetter((prevIndex) => {
                      const newIndex = (prevIndex + 1) % optionRef.current.length;
                      optionRef.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                      return newIndex;
                    });
                  }
                }
                else if (e.key === 'ArrowUp') {
                  e.preventDefault();
                  if(optionRef.current.length > 0)
                  {
                    highlightIndexSetter((prevIndex) => {
                      const newIndex = (prevIndex - 1 + optionRef.current.length) % optionRef.current.length;
                      optionRef.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                      return newIndex;
                    });
                  }
                }
              }} key={index} value={""}
            >
              <Icon icon="ph:info" className="text-info me-1" style={{ width: "20px", height: "20px" }} />
              {"Search POI by typing #POI Name"}
            </li>
          );
        }
        if(inputFilter || shouldShowAll){
          if(type === "AutoComplete")
          {
            let detailedDataAuto = {
              city: "",
              state: "",
              zip: ""
            };
            item.address_components.forEach((component)=>{
              if(component.types.includes("locality"))
              {
                detailedDataAuto.city = component.long_name;
              }
              if (component.types.includes("administrative_area_level_1")) {
                detailedDataAuto.state = component.short_name;
              }
              if (component.types.includes("postal_code")) {
                detailedDataAuto.zip = component.long_name;
              }
            });
            detailedData = detailedDataAuto.city+","+detailedDataAuto.state+","+detailedDataAuto.zip;
            LatLng = String(item.geometry.location.lat) +","+ String(item.geometry.location.lng);
          }
          if(shouldShowAll){
            try {
              let result = ParseGeoCodedData(item, "", index);
              addressComponentRef.current[index] = result;
            } catch (err) {console.log(err);}
          }
          else if(isRecent === "recent"){
            try {
              addressComponentRef.current[index] = item;
            } catch (err) {console.log(err);}
          }
          return(
            <li ref={optionRef.current[index]} {...isRecentAddress} className="small border-bottom text-nowrap overflow-hidden addressSelectionRow" 
              title={formattedAddr} onFocus={()=>{focusedOptionRef.current = true;}} style={{cursor:"pointer"}} tabIndex={-1} onBlur={()=>{focusedOptionRef.current = false;}} 
              onKeyDown={(e)=>{
                if(e.key === 'ArrowDown')
                {
                  e.preventDefault();

                  if(optionRef.current.length > 0)
                  {
                    highlightIndexSetter((prevIndex) => {
                      const newIndex = (prevIndex + 1) % optionRef.current.length;
                      optionRef.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                      return newIndex;
                    });
                  }
                }
                else if (e.key === 'ArrowUp') {
                  e.preventDefault();
                  if(optionRef.current.length > 0)
                  {
                    highlightIndexSetter((prevIndex) => {
                      const newIndex = (prevIndex - 1 + optionRef.current.length) % optionRef.current.length;
                      optionRef.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                      return newIndex;
                    });
                  }
                }
                else if(e.key === "Enter")
                {
                  handleFunction(e);
                }
              }} onClick={handleFunction} key={index} value={formattedAddr} data-name={detailedData} data-virtual={LatLng}
            >
              {formattedAddr}
            </li>
          );
        }

      }) : "";

      return suggestionHTML;
    }
    catch(err){ console.log(err); return ""; }
  };

  async function handleHomeSuggestionSelected (e) {
    try{
      let LatLng = e.target.dataset.virtual;
      let addressDetails = e.target.getAttribute('data-name');
      if(LatLng.split(",")[0] !== "0" && LatLng.split(",")[0] !== "")
      {
        let poiSelected = e.target.getAttribute('poisuggestion')
        let selectedAddressContext = (poiSelected ? e.target.title : e.target.textContent);
       

        setHomeAddr(selectedAddressContext);
        setHomePOI((poiSelected? e.target.textContent : ""));
        addressInfoDetails.current = {state:addressDetails.split(",")[1], city: addressDetails.split(",")[0], zip: addressDetails.split(",")[2]};
        homeAddrLatLng.current = e.target.dataset.virtual;
        setAddrLat(e.target.dataset.virtual.split(',')[0]? e.target.dataset.virtual.split(',')[0] : "")
        setAddrLng(e.target.dataset.virtual.split(',')[1]? e.target.dataset.virtual.split(',')[1] : "")

        setShowAPILoader(false);
        setInputSuggestionListAddress("");
      }
      else if(e.target.getAttribute('poisuggestion'))
      {
        let OSRMResponse = await handleOSRMAutoComplete(e.target.title);
        if(OSRMResponse && OSRMResponse.data.status.toUpperCase() === "OK")
        {
          let addressFound = OSRMResponse.data.results[0];
          let selectedAddressContext = addressFound.formatted_address;

          setHomeAddr(selectedAddressContext);
          setHomePOI(e.target.textContent);
          addressInfoDetails.current = {state:addressDetails.split(",")[1], city: addressDetails.split(",")[0], zip: addressDetails.split(",")[2]};
          homeAddrLatLng.current = addressFound.geometry.location.lat+","+addressFound.geometry.location.lng;
          setAddrLat(addressFound.geometry.location.lat? addressFound.geometry.location.lat : "")
          setAddrLng(addressFound.geometry.location.lng? addressFound.geometry.location.lng : "")
          setShowAPILoader(false);
          setInputSuggestionListAddress("");
        }
      }
    }
    catch (err) {console.log(err);}
  }

  const formatPhone = (phoneVal) => {
    try{
      const cleanedPhone = phoneVal.replace("+1", "");
      return `${cleanedPhone.substring(0, 3)}-${cleanedPhone.substring(3, 6)}-${cleanedPhone.substring(6)}`;
    }
    catch(err){console.log(err); return phoneVal;}
  };

  async function saveNewClientPreCheckHandler () {
    try{
      let preCheckValid = true;
      const headerTxt = 'Save Client Profile Alert';
      let bodyTxt = '';

      if(!(profileContactInfo.phone) || profileContactInfo.phone.length < 12){
        bodyTxt = 'Please enter the full phone number before saving the profile.';
        preCheckValid = false;
      }
      else if(clientFirstName.trim().length < 2 || clientLastName.trim().length < 2){
        bodyTxt = 'Please enter the full client name before saving the profile.';
        preCheckValid = false;
      }
      else if(!(homeAddrLatLng.current) || homeAddrLatLng.current === ''){
        bodyTxt = 'Please select a home address from the suggestion dropdown before saving the profile.';
        preCheckValid = false;
      }
      else if(selectedFamilyID === 'DTSP'){
        bodyTxt = 'Please select a company name before saving the profile.';
        preCheckValid = false;
      }
      else if(selectedStatus === 'Status'){
        bodyTxt = 'Please select a client status before saving the profile.';
        preCheckValid = false;
      }

      if(preCheckValid){
        await handleClientStatusValidation();
      }
      else{
        setModalHeaderTextExtra(headerTxt);
        setModalBodyHTMLExtra(bodyTxt);
        setModalFooterHTMLExtra(
          <Button variant='dark' className="border-0" onClick={()=>setShowDynamicExtraModal(false)}>
            OK
          </Button>
        );
        setShowDynamicExtraModal(true);
        createNewProfileBtnRef.current.disabled = false; 
        setShowAPILoader(false);
      }
    }
    catch(err){console.log(err); createNewProfileBtnRef.current.disabled = false; setShowAPILoader(false);} 
  }

  async function handleClientStatusValidation () {
    try{
      let homePhone = (profileContactInfo.phone ? formatPhone(profileContactInfo.phone) : '');
      let cellPhone = (profileContactInfo.cell ? formatPhone(profileContactInfo.cell) : '');
      let selectedFamilyData = AffiliateData.filter((item)=>{
        if(parseInt(item.AffiliateID) === parseInt(providedAff))
        {
          return true;
        }
      });
      const statusval = (selectedStatus === 'Status' ? 0 : parseInt(selectedStatus));
      const statusText = statusOptionsArr.find(item=> parseInt(item.iID) === statusval)?.vName ?? '';
      let data = {
        "lastName": clientLastName,
        "firstName": clientFirstName,
        "homePhoneNo": homePhone,
        "cellPhoneNo": cellPhone,
        "ATSPFamilyID": (selectedFamilyID !== 'DTSP' ? parseInt(selectedFamilyID) : parseInt(selectedFamilyData[0].DTSPID)),
        "status": statusText,
        "mode": "New"
      };
      setShowAPILoader(true);
      let response = await APICom.fetchData("ReservationCoreURL","api/ParatransitCT/CustomerStatusValidation", "post", { "Content-Type": "application/json" }, data, null);
      if(response && response.error === ''){
        const StatusResp = JSON.parse(response.data);
        if(StatusResp.Status === 'True'){
          if(StatusResp.duplicateClient === 'False'){
            await handleValidateSaveNewClient(true);
          }
          else{
            setModalHeaderTextExtra("Duplicate Info");
            setModalBodyHTMLExtra("A duplicate profile exists for this client, please try a different name or number.");
            setModalFooterHTMLExtra(
              <Button variant='dark' className="border-0" onClick={()=>setShowDynamicExtraModal(false)}>
                OK
              </Button>
            );
            setShowDynamicExtraModal(true);
            createNewProfileBtnRef.current.disabled = false;
            setShowAPILoader(false);
          }
        }
        else
        {
          setModalHeaderTextExtra("Invalid Info Alert");
          setModalBodyHTMLExtra("This action is not allowed, please try again later.");
          setModalFooterHTMLExtra(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicExtraModal(false)}>
              OK
            </Button>
          );
          setShowDynamicExtraModal(true);
          createNewProfileBtnRef.current.disabled = false;
          setShowAPILoader(false);
        }
      }
    }
    catch(err){console.log(err); createNewProfileBtnRef.current.disabled = false; setShowAPILoader(false);}
  }

  async function handleValidateSaveNewClient (bvalid = false) {
    try{
      createNewProfileBtnRef.current.disabled = true;
      if(!bvalid){
        saveNewClientPreCheckHandler();
        return 0;
      }
      const bShowPhone = (showPhone === 'yes' ? true : false);
      const bActiveProf = (activeProfile === 'yes' ? true : false);
      const homeContact = (profileContactInfo.phone ? formatPhone(profileContactInfo.phone) : '');
      const officeContact = (profileContactInfo.office ? formatPhone(profileContactInfo.office) : '');
      const cellContact = (profileContactInfo.cell ? formatPhone(profileContactInfo.cell) : '');
      const mobilityID = (mobilityType === 'amb' ? 0 : (mobilityType === 'wc' ? 1 : 2));
      const lang = (selectedLanguage !== 'Language' ? parseInt(selectedLanguage) : 1);
      let data = {
        "lastName": clientLastName,
        "firstName": clientFirstName,
        "accountNumber": paymentInfo.accountNo,
        "company": selectedCompanyName,
        "homePhoneNo": homeContact,
        "officePhoneNo": officeContact,
        "cellPhoneNo": cellContact,
        "email": profileContactInfo.email,
        "address1": (homeAddr.includes(",") ? homeAddr.split(",")[0] : homeAddr),
        "address2": "",
        "country": "USA",
        "city": addressInfoDetails.current.city,
        "state": addressInfoDetails.current.state,
        "zip": addressInfoDetails.current.zip,
        "remarks": tripInfo.remarks,
        "notes": tripInfo.agentNotes,
        "statusId": (selectedStatus === 'Status' ? 0 : parseInt(selectedStatus)),
        "createdUserId": parseInt(loginData.iUserIDActual),
        "paymentTypeId": parseInt(paymentInfo.payID),
        "rcTypePhone": tripInfo.RollCall.phone,
        "rcTypeSMS": tripInfo.RollCall.sms,
        "rcTypeEmail": tripInfo.RollCall.email,
        "showPhone": bShowPhone,
        "active": bActiveProf,
        "modifiedUserId": parseInt(loginData.iUserIDActual),
        "atspFamilyID": parseInt(selectedFamilyID),
        "langID": lang,
        "slaClassId": parseInt(tripInfo.SLA),
        "fundingSourceId": paymentInfo.FSID,
        "ambulatoryCount": (mobilityType === 'amb' ? 1 : 0),
        "wheelChairCount": (mobilityType !== 'amb' ? 1 : 0),
        "dateOfBirth": (profileContactInfo.DOB !== '' ? profileContactInfo.DOB : '1900-01-01'),
        "mobilityID": mobilityID,
        "Addr1Lat" : addrLat,
        "Addr1Lng":  addrLng
      }
      let response = await APICom.fetchData("ReservationCoreURL","api/ParatransitCT/SaveNewClientProfile", "post", { "Content-Type": "application/json" }, data, null);
      if(response && response.error === ""){
        const respData = JSON.parse(response.data);
        // console.log(respData);
        if(respData.Result === 'true'){
          const AccountNo = respData.ClientID;
          const fullName = clientFirstName.trim() + " " + clientLastName.trim();
          const phoneNo = profileContactInfo.phone;
          props.setExtraInfo({
            language: lang, passType: mobilityType, agentNotes: tripInfo.agentNotes, ID: String(AccountNo),
            remarks: tripInfo.remarks, email: profileContactInfo.email, 
            rollcall: {phone: (tripInfo.RollCall.phone), sms: (tripInfo.RollCall.sms), 
            email: (tripInfo.RollCall.email)}, priority: parseInt(tripInfo.SLA), name: fullName, 
            affDetails: {affID: parseInt(providedAff), FSID: parseInt(selectedFamilyID)}, phone: phoneNo
          });
          customHideFunc();
        }
        else{
          setModalHeaderTextExtra("Save Client Error");
          setModalBodyHTMLExtra('An issue occurred while saving client profile, please try again.');
          setModalFooterHTMLExtra(
            <Button variant='dark' className="border-0" onClick={()=>setShowDynamicExtraModal(false)}>
              OK
            </Button>
          );
          setShowDynamicExtraModal(true);
        }

      }
      else if(response.error.length > 0){
        setModalHeaderTextExtra("Save Client Error");
        setModalBodyHTMLExtra(response.error);
        setModalFooterHTMLExtra(
          <Button variant='dark' className="border-0" onClick={()=>setShowDynamicExtraModal(false)}>
            OK
          </Button>
        );
        setShowDynamicExtraModal(true);
      }
      createNewProfileBtnRef.current.disabled = false;
      setShowAPILoader(false);
    }
    catch(err){console.log(err); createNewProfileBtnRef.current.disabled = false; setShowAPILoader(false);}
  }

  async function handleFamilyIDChange (e) {
    try{
      
      let newAffData = AffiliateData.filter(item => parseInt(item.DTSPID) === parseInt(e.target.value));
      const newAff = (newAffData.length > 0 ? newAffData[0] : providedAff);
      let newAffFSData = (FundingSourceData[parseInt(newAff)] ? JSON.parse(FundingSourceData[parseInt(newAff)]) : []);
      const newFSFiltered = (newAffFSData.length > 0 ? newAffFSData[0] : []);
      if(newFSFiltered.length > 0){
        let activeProf = (newFSFiltered.Active ? 'yes' : 'no');
        let paymentType = (newFSFiltered.PaymentTypeID || -1);
        let priorityType = newFSFiltered.SLAClassID ? parseInt(newFSFiltered.SLAClassID) : 5;
        let accountNo = newFSFiltered.AccountNumber ? newFSFiltered.AccountNumber : '';
        let fsID = newFSFiltered.FID;
        setTripInfo(prev=>({...prev, SLA: priorityType}));
        setActiveProfile(activeProf);
        setPaymentInfo({accountNo: accountNo, payID: paymentType, FSID:parseInt(fsID)})

      }

      setProvidedAff(newAff);
      setSelectedFamilyID(e.target.value); 
      await handleClientStatusDropdownGeneration(e.target.value);
      setSelectedCompanyName(e.target.textContent);
    }
    catch(err){console.log(err);}
  }

  function handleOnBlurDOBFunc (e) {
    try{
      let dateGiven = e.target.value;
      const minDate = new Date("1900-01-01 00:00:00");
      const selectedDate = new Date(dateGiven + " 00:00:00");
      const maxDate = new Date();
      if(selectedDate < minDate || isNaN(selectedDate.getTime()) || selectedDate > maxDate){
        setProfileContactInfo(pre=>({...pre, DOB: '1900-01-01'}));
      }
    }
    catch(err){console.log(err);}
  }

  function confirmDialogClose (e) {
    try{
      setModalHeaderTextExtra("Cancel Client Creation");
      setModalBodyHTMLExtra('Are you sure that you would like to cancel the profile creation? The entered data will be discarded.');
      setModalFooterHTMLExtra(
        <>
          <Button variant='dark' className="border-0" onClick={() => {
              customHideFunc();
              if (props.onCancelProfileCreation) {
                  props.onCancelProfileCreation();
              }
          }}>
            Yes
          </Button>
          <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicExtraModal(false)}>
            No
          </Button>
        </>
      );
      setShowDynamicExtraModal(true);
    }
    catch(err){console.log(err);}
  }


  return (
    <>  
      {ShowAPILoader ? <div className="loader" style={{zIndex:10000}}></div> : ""}
      <Modal centered className={``} backdrop="static" keyboard={true} onHide={confirmDialogClose} size="lg" show={showDynamicModal} animation={true}>
        <Modal.Header className='text-white user-select-none p-0 py-1 px-2 callAgent-modal-header' closeButton>
          <Modal.Title style={{fontSize:"20px"}}>
            {"Add Client Profile"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='fw-normal user-select-none'>
          <p className='m-0 mx-1 d-flex text-nowrap overflow-hidden fw-bold fs-6 user-select-none my-auto small text-start' style={{minWidth:"120px", textOverflow:"ellipsis"}}>
            {"Basic Info"}<span className="text-danger">{"*"}</span>
          </p>
          <Row className="m-0 mt-1">
            <Col xs={6}>
              <span className="user-select-none my-auto d-flex w-100">
                {screenWidth >= 991 ?
                  <p className='m-0 mx-1 d-inline-flex text-nowrap overflow-hidden user-select-none my-auto small text-center' style={{width:"67px", maxWidth:"67px"}}>
                    {"First Name"}
                  </p> 
                : ""}
                <input type={"text"} value={clientFirstName} autoComplete="new_pass" minLength={4} maxLength={20} required 
                  onChange={(e)=>{setClientFirstName(e.target.value)}} tabIndex={0} disabled={enteredMainInfoFlag.name}
                  className={`${screenWidth >= 991 ? '' : 'w-100'} text-nowrap p-0 px-1 callAgentInputStyle`} placeholder="First Name"
                  style={{maxHeight:"30px", height:"30px"}} title={(screenWidth >= 991 ? '' : 'First Name')}
                /> 
              </span>
              
            </Col>
            <Col xs={6}>
              <span className="user-select-none my-auto d-flex w-100">
                {screenWidth >= 991 ?
                  <p className='m-0 mx-1 d-flex text-nowrap overflow-hidden user-select-none my-auto small text-center' style={{width:"67px", maxWidth:"67px"}}>
                    {"Last Name"}
                  </p>
                : ""}
                <input type={"text"} value={clientLastName} autoComplete="new_pass" minLength={4} maxLength={20} required 
                  onChange={(e)=>{setClientLastName(e.target.value)}} tabIndex={0} disabled={enteredMainInfoFlag.name}
                  className={`${screenWidth >= 991 ? '' : 'w-100'} text-nowrap p-0 px-1 callAgentInputStyle`} placeholder="Last Name"
                  style={{maxHeight:"30px", height:"30px"}} title={(screenWidth >= 991 ? '' : 'Last Name')}
                /> 
              </span>
            </Col>
          </Row>
          <Row className="m-0 mt-1">
            <Col xs={6}>
              <span className="user-select-none my-auto d-flex w-100">
                {screenWidth >= 991 ?
                  <p className='m-0 mx-1 d-flex text-nowrap overflow-hidden user-select-none my-auto small text-center' style={{width:"67px", maxWidth:"67px"}}>
                    {"Address"}
                  </p>
                : ""}
                <input type={"search"} autoComplete="new_pass" value={homeAddr} placeholder="Home Address" 
                  title={(homeAddr !== '' ? 'Home Address (Search POI by typing #POI Name): ' + homeAddr : 'Home Address (Search POI by typing #POI Name)')} onChange={handleHomeAddressSuggestion}
                  style={{ textOverflow:"ellipsis", maxHeight:"30px", height:"30px"}} 
                  className={`${screenWidth >= 991 ? '' : 'w-100'} text-nowrap d-inline-flex px-1 p-0 callAgentInputStyle`} 
                  onFocus={handleHomeAddressSuggestion} onBlur={()=>{setTimeout(() => {
                    if(!focusedSuggestionCheckAddress.current)
                    {
                      setInputSuggestionListAddress("");
                    }
                  }, 300);}}
                  onKeyDown={(e)=>{
                    if(e.key === 'ArrowDown')
                    {
                      e.preventDefault();
                      setHighlightedIndex(-1);
                      if(liRefs.current.length > 0)
                      {
                        if(liRefs.current[0]?.current) //check for empty references
                        {
                          setHighlightedIndex((prevIndex) => {
                            const newIndex = (prevIndex + 1) % liRefs.current.length;
                            liRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                            return newIndex;
                          });
                        }
                      }
                    }
                    else if (e.key === 'ArrowUp') {
                      e.preventDefault();
                      setHighlightedIndex(-1);
                      if(liRefs.current.length > 0)
                      {
                        if(liRefs.current[0]?.current)
                        {
                          setHighlightedIndex((prevIndex) => {
                            const newIndex = (prevIndex - 1 + liRefs.current.length) % liRefs.current.length;
                            liRefs.current[newIndex]?.current.focus(); // Focus the newly highlighted element
                            return newIndex;
                          });
                        }
                      }
                    }
                  }}
                />
                {inputSuggestionListAddress && inputSuggestionListAddress !== "" ?
                  <ul tabIndex={0} className={`user-select-none border position-absolute px-1 mt-4 ms-3`} 
                    style={{width:"auto", maxWidth:"400px", height:"80px", overflowY:"auto", zIndex:1000, backgroundColor:"#e6eef1"}} 
                  >
                    {inputSuggestionListAddress}
                  </ul>
                :""}
              </span>
            </Col>
            <Col xs={6} className="my-auto">
                <span className="user-select-none my-auto d-flex w-100">
                  <p className='m-0 mx-1 d-flex text-nowrap overflow-hidden user-select-none my-auto small text-center' 
                    style={{width:"67px", maxWidth:"67px"}} title={"Active Client Profile"}
                  >
                    {"Active"}
                  </p>
                  <input type="radio" className="" name="ActiveProf" value={"yes"} style={{cursor:"pointer"}} 
                    checked={activeProfile === 'yes'} onChange={(e)=>{setActiveProfile(e.target.value);}}
                  />
                  <label className='mx-1 small'>Yes</label>
                  <input type="radio" className="ms-3" name="ActiveProf" value={"no"} style={{cursor:"pointer"}} 
                    checked={activeProfile === 'no'} onChange={(e)=>{setActiveProfile(e.target.value);}}
                  />
                  <label className='mx-1 small'>No</label>
                </span>
            </Col>
          </Row>
          <Row className="m-0 mt-1">
            <Col xs={6}>
              <span className="user-select-none my-auto d-flex w-100">
                <p className='m-0 mx-1 d-flex text-nowrap overflow-hidden user-select-none my-auto small text-center' 
                  style={{width:"67px", maxWidth:"67px"}} title={"Default Transportation Service Provider"}
                >
                  {"DTSP"}
                </p>
                <select className='text-center p-1 w-100 callAgentInputStyle' style={{width: '189px', maxWidth:"189px", maxHeight:"30px", height:"30px"}} value={selectedFamilyID}
                  onChange={handleFamilyIDChange}
                >
                  <option value={"DTSP"} disabled hidden>{"Select DTSP"}</option>
                  <option value={"DTSP"}>{"None"}</option>
                  <>
                    {DTSPOptionsHTML}
                  </>
                </select>
              </span>
            </Col>
            <Col xs={6}>
              <span className="user-select-none my-auto d-flex w-100">
                {screenWidth >= 991 ?
                  <p className='m-0 mx-1 d-flex text-nowrap overflow-hidden user-select-none my-auto small text-center' 
                    style={{width:"67px", maxWidth:"67px"}}
                  >
                    {"Language"}
                  </p>
                : ""}
                <select className='text-center p-1 w-100 callAgentInputStyle' style={(screenWidth >= 991 ? {width: '189px', maxWidth:"189px", maxHeight:"30px", height:"30px"} : {maxHeight:"30px", height:"30px"})} value={selectedLanguage}
                  onChange={(e)=>{setSelectedLanguage(e.target.value);}} title={(screenWidth >= 991 ? '' : 'Language')}
                >
                  <option value={"Language"}>{"None"}</option>
                  <>
                    {languageOptionsHTML}
                  </>
                </select>
              </span>
            </Col>
          </Row>
          <Row className="m-0 border-bottom border-secondary py-1">
            <Col xs={6}>
              <span className="user-select-none my-auto d-flex w-100">
                <p className='m-0 mx-1 d-flex text-nowrap overflow-hidden user-select-none my-auto small text-center' 
                  style={{width:"67px", maxWidth:"67px"}} title={"Client Status"}
                >
                  {"Status"}
                </p>
                <select className='text-center p-1 w-100 callAgentInputStyle' style={{width: '189px', maxWidth:"189px", maxHeight:"30px", height:"30px"}} value={selectedStatus}
                  onChange={(e)=>{setSelectedStatus(e.target.value);}}
                >
                  <option value={"Status"} disabled hidden>{"Select..."}</option>
                  <option value={"Status"}>{"None"}</option>
                  <>
                    {statusOptionsHTML}
                  </>
                </select>
              </span>
            </Col>
          </Row>
          <p className='m-0 mx-1 mt-1 d-flex text-nowrap overflow-hidden fw-bold fs-6 user-select-none my-auto small text-start' style={{minWidth:"140px", textOverflow:"ellipsis"}}>
            {"Contact Info"}
          </p>
          <Row className="m-0 mt-1">
            <Col xs={6} className="d-flex">
              <p className='m-0 mx-1 d-flex text-nowrap overflow-hidden user-select-none my-auto small text-center' 
                style={{width:"67px", maxWidth:"67px"}}
              >
                {"Phone"}<span className="text-danger">{"*"}</span>
              </p>
              <Form className="d-inline-flex">
                <PhoneInput className='text-nowrap text-center w-100 callAgentInputStyle p-1' style={{width: '189px', maxWidth:"189px", maxHeight:"30px", height:"30px"}}
                  defaultCountry="US" value={profileContactInfo.phone} onChange={(e)=>{setProfileContactInfo(prevState=>({...prevState, phone: e}));}} 
                  placeholder="(XXX) XXX-XXXX" autoComplete="new_pass" disabled={enteredMainInfoFlag.phone}
                  onKeyDown={(e)=>{
                    let input = e.target.value;
                    if((e.key === '1' || e.key === '0') && (input.length === 0 || (input.length > 0 && (input.charAt(0) === "1" || input.charAt(0) === "0"))))
                    {
                      e.preventDefault();
                    } 
                    if(e.target.value.length >= 14 && e.key !== 'Backspace' && e.key !== "Delete" && e.key !== "Tab")
                    {e.preventDefault();}
                  }}
                /> 
              </Form>
            </Col>
            <Col xs={6}>
              <span className="user-select-none my-auto d-flex w-100">
                {screenWidth >= 991 ?
                  <p className='m-0 mx-1 d-flex text-nowrap overflow-hidden user-select-none my-auto small text-center' style={{width:"67px", maxWidth:"67px"}}>
                    {"Email"}
                  </p>
                : ""}
                <input type={"text"} value={profileContactInfo.email} autoComplete="new_pass" minLength={4}
                  onChange={(e)=>{setProfileContactInfo(prevState=>({...prevState, email: e.target.value}));}} tabIndex={0}
                  className={`${screenWidth >= 991 ? '' : 'w-100'} text-nowrap p-0 px-1 callAgentInputStyle`} placeholder="Email"
                  style={{maxHeight:"30px", height:"30px"}} title={(screenWidth >= 991 ? '' : 'Email Address')}
                /> 
              </span>
            </Col>
          </Row>
          <Row className="m-0 mt-1">
            <Col xs={6} className="d-flex">
              <p className='m-0 mx-1 d-flex text-nowrap overflow-hidden user-select-none my-auto small text-center' 
                style={{width:"67px", maxWidth:"67px"}} title="Cell Phone"
              >
                {"Cell"}
              </p>
              <Form className="d-inline-flex">
                <PhoneInput className='text-nowrap text-center w-100 callAgentInputStyle p-1' style={{width: '189px', maxWidth:"189px", maxHeight:"30px", height:"30px"}}
                  defaultCountry="US" value={profileContactInfo.cell} onChange={(e)=>{setProfileContactInfo(prevState=>({...prevState, cell: e}));}} placeholder="(XXX) XXX-XXXX" autoComplete="new_pass"
                  onKeyDown={(e)=>{
                    let input = e.target.value;
                    if((e.key === '1' || e.key === '0') && (input.length === 0 || (input.length > 0 && (input.charAt(0) === "1" || input.charAt(0) === "0"))))
                    {
                      e.preventDefault();
                    } 
                    if(e.target.value.length >= 14 && e.key !== 'Backspace' && e.key !== "Delete" && e.key !== "Tab")
                    {e.preventDefault();}
                  }}
                /> 
              </Form>
            </Col>
            <Col xs={6} className="d-flex">
              <p className='m-0 mx-1 d-flex text-nowrap overflow-hidden user-select-none my-auto small text-center' 
                style={{width:"67px", maxWidth:"67px"}} title="Office Phone"
              >
                {"Office"}
              </p>
              <Form className="d-inline-flex">
                <PhoneInput className='text-nowrap text-center w-100 callAgentInputStyle p-1' style={{width: '189px', maxWidth:"189px", maxHeight:"30px", height:"30px"}}
                  defaultCountry="US" value={profileContactInfo.office} onChange={(e)=>{setProfileContactInfo(prevState=>({...prevState, office: e}));}} placeholder="(XXX) XXX-XXXX" autoComplete="new_pass"
                  onKeyDown={(e)=>{
                    let input = e.target.value;
                    if((e.key === '1' || e.key === '0') && (input.length === 0 || (input.length > 0 && (input.charAt(0) === "1" || input.charAt(0) === "0"))))
                    {
                      e.preventDefault();
                    } 
                    if(e.target.value.length >= 14 && e.key !== 'Backspace' && e.key !== "Delete" && e.key !== "Tab")
                    {e.preventDefault();}
                  }}
                /> 
              </Form>
            </Col>
          </Row>
          <Row className="m-0 border-bottom border-secondary py-1">
            <Col xs={6} className="my-auto">
              <span className="user-select-none my-auto d-flex w-100">
                <p className='m-0 mx-1 ms-0 d-flex text-nowrap overflow-hidden user-select-none my-auto text-center' 
                  style={{width:"67px", maxWidth:"67px", fontSize:"12px"}}
                >
                  {"Show Phone"}
                </p>
                <input type="radio" className="ms-1" name="PhoneProf" value={"yes"} style={{cursor:"pointer"}} 
                  checked={showPhone === 'yes'} onChange={(e)=>{setShowPhone(e.target.value);}}
                />
                <label className='mx-1 small'>Yes</label>
                <input type="radio" className="ms-3" name="PhoneProf" value={"no"} style={{cursor:"pointer"}} 
                  checked={showPhone === 'no'} onChange={(e)=>{setShowPhone(e.target.value);}}
                />
                <label className='mx-1 small'>No</label>
              </span>
            </Col>
            <Col xs={6}>
              <span className="user-select-none my-auto d-flex w-100">
                {screenWidth >= 991 ?
                  <p className='m-0 mx-1 d-inline-flex text-nowrap overflow-hidden user-select-none my-auto small text-center' style={{width:"67px", maxWidth:"67px"}}>
                    {"Notes"}
                  </p>
                : 
                  <span className="user-select-none my-auto d-flex text-center mx-auto small overflow-hidden" style={{width:"48px"}} title={"Agent Notes"}>
                    <Icon icon="system-uicons:clipboard-notes" className="my-auto text-info w-100" width="25px" height="25px"/>
                  </span>
                }
                <textarea
                  rows={2}
                  cols={10}
                  placeholder="Agent Notes..."
                  style={{resize:"none", width: '189px', maxWidth:"189px"}} autoComplete="new_pass"
                  value={tripInfo.agentNotes} onChange={(e)=>{setTripInfo(prevS=>({...prevS, agentNotes: e.target.value}));}}
                  className={`${screenWidth >= 991 ? '' : 'ms-4'} tripDetails-label-dataFields d-inline-flex w-100 callAgentInputStyle px-1`}
                />
              </span>
            </Col>
          </Row>
          <p className='m-0 mx-1 mt-1 d-flex text-nowrap overflow-hidden fw-bold fs-6 user-select-none my-auto small text-start' style={{minWidth:"140px", textOverflow:"ellipsis"}}>
            {"Mobility Info"}
          </p>
          <Row className="m-0 border-bottom border-secondary py-1">
            <Col xs={6}>
              <span className="user-select-none my-auto d-flex w-100">
                <p className='m-0 mx-1 d-inline-flex text-nowrap overflow-hidden user-select-none my-auto small text-center' style={{width:"67px", maxWidth:"67px"}}>
                  {"DOB"}
                </p>
                <input type="date" name="dateGiven" autoComplete="new_pass" value={profileContactInfo.DOB}  onBlur={handleOnBlurDOBFunc}
                  onChange={(e)=>{setProfileContactInfo(prevState=>({...prevState, DOB: e.target.value}));}} min={'1900-01-01'}
                  className="m-0 px-1 w-100 text-center callAgentInputStyle" style={{width: '189px', maxWidth:"189px", maxHeight:"30px", height:"30px"}} 
                />
              </span>
            </Col>
            <Col xs={6} className="my-auto">
              <span className="user-select-none my-auto d-flex w-100 overflow-hidden">
                {screenWidth >= 991 ?
                  <p className='m-0 mx-1 d-flex text-nowrap overflow-hidden user-select-none small my-auto text-center' 
                    style={{width:"67px", maxWidth:"67px"}}
                  >
                    {"Mobility"}
                  </p>
                : ""}
                <input type="radio" className="" name="medicalProf" value={"amb"} style={{cursor:"pointer"}} 
                  checked={mobilityType === 'amb'} onChange={(e)=>{setMobilityType(e.target.value);}} title={"Ambulatory Passenger"}
                />
                {screenWidth >= 991 ? <label className='mx-1 small'>Ambulatory</label> : <Icon icon="bx:group" className="my-auto text-secondary" style={{width:"25px", height:"25px"}}/>}
                <input type="radio" className="ms-1" name="medicalProf" value={"wc"} style={{cursor:"pointer"}} title={"WheelChair"}
                  checked={mobilityType === 'wc'} onChange={(e)=>{setMobilityType(e.target.value);}}
                />
                {screenWidth >= 991 ? <label className='mx-1 small'>WheelChair</label> : <Icon icon="bx:handicap" className="my-auto text-primary" style={{width:"25px", height:"25px"}}/>}
                <input type="radio" className="ms-1" name="medicalProf" value={"walker"} style={{cursor:"pointer"}} 
                  checked={mobilityType === 'walker'} onChange={(e)=>{setMobilityType(e.target.value);}} title={"Walker"}
                />
                {screenWidth >= 991 ? <label className='mx-1 small'>Walker</label> : <Icon icon="material-symbols:assist-walker" className="my-auto text-warning" width="25px" height="25px"/>}
              </span>
            </Col>
          </Row>
          <p className='m-0 mx-1 mt-1 d-flex text-nowrap overflow-hidden fw-bold fs-6 user-select-none my-auto small text-start' style={{minWidth:"140px", textOverflow:"ellipsis"}}>
            {"Trip Info"}
          </p>
          <Row className="m-0 mt-1">
            <Col xs={6}>
              <span className="user-select-none my-auto d-flex w-100">
                <p className='m-0 mx-1 d-inline-flex text-nowrap overflow-hidden user-select-none my-auto small text-center' style={{width:"67px", maxWidth:"67px"}}>
                  {"Priority"}
                </p>
                <select className='text-center d-inline-block p-1 w-100 callAgentInputStyle' style={{width: '189px', maxWidth:"189px", height:"30px", maxHeight:"30px"}}
                  value={tripInfo.SLA} onChange={(e)=>{setTripInfo(prevS=>({...prevS, SLA: e.target.value}));}}
                > 
                  <option value={1}>{"P1"}</option>
                  <option value={2}>{"P2"}</option>
                  <option value={3}>{"P3"}</option>
                  <option value={4}>{"P4"}</option>
                  <option value={5}>{"P5"}</option>
                </select>
              </span>
            </Col>
            <Col xs={6} className="my-auto">
              <span className="user-select-none my-auto d-flex w-100">
                {screenWidth >= 991 ?
                  <p className='m-0 mx-1 d-flex text-nowrap overflow-hidden user-select-none small my-auto text-center' 
                    style={{width:"67px", maxWidth:"67px"}}
                  >
                    {"RollCall"}
                  </p>
                : ""}
                <input type="checkbox" className="" style={{cursor:"pointer"}} 
                  checked={tripInfo.RollCall.phone} onChange={(e)=>{setTripInfo(prevS=>({...prevS, RollCall: {...prevS.RollCall, phone: e.target.checked}}));}}
                />
                <label className='mx-1 small'>Phone</label>
                <input type="checkbox" className="ms-1" style={{cursor:"pointer"}} 
                  checked={tripInfo.RollCall.sms} onChange={(e)=>{setTripInfo(prevS=>({...prevS, RollCall: {...prevS.RollCall, sms: e.target.checked}}));}}
                />
                <label className='mx-1 small'>SMS</label>
                <input type="checkbox" className="ms-1" style={{cursor:"pointer"}} 
                  checked={tripInfo.RollCall.email} onChange={(e)=>{setTripInfo(prevS=>({...prevS, RollCall: {...prevS.RollCall, email: e.target.checked}}));}}
                />
                <label className='mx-1 small'>Email</label>
              </span>
            </Col>
          </Row>
          <Row className="m-0 mt-1">
            <Col xs={6}>
              <span className="user-select-none my-auto d-flex w-100">
                {screenWidth >= 991 ?
                  <p className='m-0 mx-1 d-inline-flex text-nowrap overflow-hidden user-select-none my-auto small text-center' style={{width:"67px", maxWidth:"67px"}}>
                    {"Remarks"}
                  </p>
                : 
                  <span className="user-select-none my-auto d-flex text-center mx-auto small overflow-hidden" style={{width:"48px"}} title={"Remarks"}>
                    <Icon icon="garden:notes-stroke-12" className="my-auto text-secondary w-100" width="15px" height="15px"/>
                  </span>
                }
                <textarea
                  rows={2}
                  cols={10}
                  placeholder="Additional Info..."
                  style={{resize:"none", width: '189px', maxWidth:"189px"}} autoComplete="new_pass"
                  value={tripInfo.remarks} onChange={(e)=>{setTripInfo(prevS=>({...prevS, remarks: e.target.value}));}}
                  className={`${screenWidth >= 991 ? '' : 'ms-4'} tripDetails-label-dataFields d-inline-flex w-100 callAgentInputStyle px-1`}
                />
              </span>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className='p-0 px-2 py-1'>
          <Button variant="dark" ref={createNewProfileBtnRef} tabIndex={0} className="mx-1 rounded" style={{ borderRadius: "0px"}} onClick={()=>{handleValidateSaveNewClient()}}>
            {"Save & Close"}
          </Button>
          <Button variant="secondary" tabIndex={0} className="mx-1 rounded" style={{ borderRadius: "0px"}} onClick={confirmDialogClose}>
            {"Cancel"}
          </Button>
        </Modal.Footer>
          
      </Modal>
      {showDynamicExtraModal ? 
        <Modal centered backdrop="static" keyboard={true}
          onHide={()=>{setShowDynamicExtraModal(false);}} show={showDynamicExtraModal} animation={true}>
            <Modal.Header className='text-white user-select-none p-0 py-1 px-2 callAgent-modal-header' closeButton>
                <Modal.Title style={{fontSize:"20px"}}>{modalHeaderTextExtra}</Modal.Title>
            </Modal.Header>
            <Modal.Body className='fw-normal user-select-none'>{modalBodyHTMLExtra}</Modal.Body>
            {modalFooterHTMLExtra === "" ? 
              ""
              :
              <Modal.Footer className='p-0 px-2 py-1'>
                {modalFooterHTMLExtra}
              </Modal.Footer>
            }
        </Modal>
      : ""}
    </>
  );

}

export default ClientProfile;